module.exports = __webpack_public_path__ + "img/picbg.aafe41ec.png";